import * as yup from "yup";

export const ValidationSchema = yup.object().shape({
  course: yup.object().required("Bu xana tələb olunur."),
});
